import { Component } from "react"

/* Moment */
import moment from "moment"

/* REST API */
import { extendSubscription, subscriptionStatus, subscriptionPrice } from "../../api/Organization"

/* Helpers */
import { utils } from "../../helpers"

/* Shared */
import { SUBSCRIPTION_STATUSES, line, metric } from "./shared"
import { kindOf } from "../transaction/shared"

/* Widgets */
import { toast, confirm } from "../common"


/* The empty form of a manual extension */
const INITIAL_FORM = { months: 1, plan: "", amount: "", comment: "" }


/* Widget Subscription Tab — the state of the term, the history of the charges and the hands of
   the administrator: a point which paid in cash or by an invoice is extended right here */
class SubscriptionTab extends Component {

    constructor(props) {
        super(props)

        this.state = {
            form: { ...INITIAL_FORM },
            price: utils.check(props.data.organization.subscriptionPrice, ""),
            saving: false
        }
    }

    /* Change the field of the extension form */
    setForm = (key, value) => {
        this.setState(previous => ({ form: { ...previous.form, [key]: value } }))
    }

    /* Choose a plan — its term fills the months of the form */
    setPlan = plan => {
        this.setState(previous => ({ form: { ...previous.form, plan: plan.key, months: plan.months, amount: plan.amount } }))
    }

    /* Extend the term by hand — the point paid in cash or by an invoice */
    extend = () => {

        /* Fields */
        const { form, saving } = this.state
        const { data, reload } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        /* Check Data */
        if (!form.months || parseInt(form.months) < 1) {
            toast.error("Укажите количество месяцев")
            return
        }

        confirm({
            title: `Продлить на ${form.months} мес.?`,
            text: "Оплата будет записана как ручная, без платёжного шлюза",
            confirmText: "Да, продлить",
            cancelText: "Отмена"
        }).then(confirmed => {

            if (!confirmed) {
                return
            }

            this.setState({ saving: true })

            extendSubscription({
                id: data.organization.id,
                months: parseInt(form.months),
                plan: form.plan ? form.plan : null,
                amount: `${form.amount}`.length > 0 ? parseInt(form.amount) : null,
                comment: form.comment ? form.comment : null
            }).then(response => {

                this.setState({ saving: false })

                if (response && response.status === 200) {
                    this.setState({ form: { ...INITIAL_FORM } })
                    reload()
                    toast.success("Подписка продлена")
                }
                else {
                    toast.error("Не удалось продлить подписку")
                }
            }).catch(() => {
                this.setState({ saving: false })
                toast.error("Не удалось продлить подписку")
            })
        })
    }

    /* Stop the term by hand or start it again */
    changeStatus = status => {

        /* Fields */
        const { saving } = this.state
        const { data, reload } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        this.setState({ saving: true })

        subscriptionStatus({ id: data.organization.id, status }).then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                reload()
                toast.success("Статус подписки изменён")
            }
            else {
                toast.error("Не удалось изменить статус")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось изменить статус")
        })
    }

    /* The monthly price of a legacy partner — an empty field returns the standard price list */
    savePrice = () => {

        /* Fields */
        const { price, saving } = this.state
        const { data, reload } = this.props

        /* The request is already on its way */
        if (saving) {
            return
        }

        this.setState({ saving: true })

        subscriptionPrice({ id: data.organization.id, price: `${price}`.length > 0 ? parseInt(price) : null }).then(response => {

            this.setState({ saving: false })

            if (response && response.status === 200) {
                reload()
                toast.success("Цена сохранена")
            }
            else {
                toast.error("Не удалось сохранить цену")
            }
        }).catch(() => {
            this.setState({ saving: false })
            toast.error("Не удалось сохранить цену")
        })
    }

    render = () => {

        /* Fields */
        const { form, price, saving } = this.state
        const { data } = this.props
        const { organization, subscription, subscriptionPayments, card, plans } = data

        const state = subscription ? utils.check(SUBSCRIPTION_STATUSES[subscription.status], { text: subscription.status, color: "grey" }) : null
        const left = subscription && subscription.currentPeriodEnd ? moment(subscription.currentPeriodEnd).diff(moment(), "days") : null

        return (
            <div className="organization-details-body">

                <div className="organization-details-metrics">
                    {metric("Статус", state ? state.text : "Нет подписки", state ? state.color : "grey")}
                    {metric("Оплачено до", organization.subscribedUntil ? moment(organization.subscribedUntil).format("DD.MM.YYYY") : "—")}
                    {metric("Осталось дней", left !== null && left > 0 ? left : 0, left !== null && left > 0 ? "green" : "red")}
                    {metric("Цена в месяц", utils.convertor(organization.subscriptionPrice ? organization.subscriptionPrice : 5000, "₸", 1), organization.subscriptionPrice ? "orange" : "")}
                </div>

                <div className="organization-details-columns">

                    <div className="organization-details-column">

                        <div className="organization-details-section">

                            <div className="organization-details-section-text">Продлить вручную</div>
                            <div className="organization-details-hint">Оплата наличными или по счёту. Списание запишется как ручное, неиспользованные дни текущего периода сохранятся.</div>

                            <div className="organization-details-plans">
                                {plans.map(plan =>
                                    <div
                                        key={plan.key}
                                        onClick={() => this.setPlan(plan)}
                                        className={`organization-details-plan ${form.plan === plan.key ? "active" : ""}`}
                                    >
                                        <div className="organization-details-plan-title">{plan.title}</div>
                                        <div className="organization-details-plan-amount">{utils.convertor(plan.amount, "₸", 1)}</div>
                                        <div className="organization-details-plan-text">{utils.convertor(plan.monthly, "₸", 1)} / мес</div>
                                    </div>
                                )}
                            </div>

                            <div className="organization-details-form">

                                <div className="organization-details-field">
                                    <span>Месяцев</span>
                                    <input type="number" min="1" value={form.months} onChange={event => this.setForm("months", event.target.value)} />
                                </div>

                                <div className="organization-details-field">
                                    <span>Сумма, ₸</span>
                                    <input type="number" min="0" placeholder="0" value={form.amount} onChange={event => this.setForm("amount", event.target.value)} />
                                </div>

                                <div className="organization-details-field wide">
                                    <span>Комментарий</span>
                                    <input placeholder="Оплата наличными" value={form.comment} onChange={event => this.setForm("comment", event.target.value)} />
                                </div>

                            </div>

                            <div onClick={() => this.extend()} className={`organization-details-button ${saving ? "disabled" : ""}`}>
                                {saving ? "Сохраняем..." : "Продлить подписку"}
                            </div>

                        </div>

                        <div className="organization-details-section">

                            <div className="organization-details-section-text">Льготная цена</div>
                            <div className="organization-details-hint">Месячная цена для давнего партнёра. Пустое поле возвращает точку на стандартный прайс — 5 000 ₸.</div>

                            <div className="organization-details-form">
                                <div className="organization-details-field">
                                    <span>Цена в месяц, ₸</span>
                                    <input type="number" min="0" placeholder="5000" value={price} onChange={event => this.setState({ price: event.target.value })} />
                                </div>
                            </div>

                            <div onClick={() => this.savePrice()} className={`organization-details-button light ${saving ? "disabled" : ""}`}>Сохранить цену</div>

                        </div>

                    </div>

                    <div className="organization-details-column">

                        {subscription &&
                            <div className="organization-details-section">
                                <div className="organization-details-section-text">Текущая подписка</div>
                                {line("Тариф", subscription.plan)}
                                {line("Сумма за период", utils.convertor(subscription.amount, "₸", 1))}
                                {line("Длительность", subscription.months ? `${subscription.months} мес.` : null)}
                                {line("Автопродление", subscription.autoRenew ? "Включено" : "Выключено")}
                                {line("Последнее списание", subscription.lastChargeAt ? moment(subscription.lastChargeAt).format("DD.MM.YYYY HH:mm") : null)}
                                {line("Отмена с", subscription.cancelAt ? moment(subscription.cancelAt).format("DD.MM.YYYY") : null)}
                                {line("Номер заказа", subscription.orderId)}
                                {line("Карта", card ? card.cardPan : "Не привязана")}
                            </div>
                        }

                        {subscription &&
                            <div className="organization-details-section">

                                <div className="organization-details-section-text">Статус подписки</div>

                                <div className="organization-details-statuses">
                                    {Object.keys(SUBSCRIPTION_STATUSES).map(key =>
                                        <div
                                            key={key}
                                            onClick={() => this.changeStatus(key)}
                                            className={`organization-details-status ${subscription.status === key ? "active" : ""}`}
                                        >
                                            {SUBSCRIPTION_STATUSES[key].text}
                                        </div>
                                    )}
                                </div>

                            </div>
                        }

                        <div className="organization-details-section">

                            <div className="organization-details-section-text">История платежей</div>

                            {subscriptionPayments.length === 0 && <div className="organization-details-empty">Платежей ещё не было</div>}

                            {subscriptionPayments.map(payment =>
                                <div key={`${payment.id}`} className="organization-details-row">
                                    <div className="organization-details-row-main">
                                        <div className="organization-details-row-title">{utils.convertor(payment.amount, "₸", 1)}</div>
                                        <div className="organization-details-row-text">
                                            {kindOf(payment.kind).text}
                                            {payment.orderId ? ` · ${payment.orderId}` : ""}
                                        </div>
                                    </div>
                                    <div className="organization-details-row-side">
                                        <div className={`tag ${payment.status === "success" ? "green" : "red"}`}>{payment.status === "success" ? "Успешно" : "Ошибка"}</div>
                                        <span>{payment.paidAt ? moment(payment.paidAt).format("DD.MM.YYYY HH:mm") : ""}</span>
                                    </div>
                                </div>
                            )}

                        </div>

                    </div>

                </div>

            </div>
        )
    }
}

export default SubscriptionTab
